import type { MutationFunction, QueryFunction } from '@tanstack/vue-query'

/* eslint-disable @typescript-eslint/no-explicit-any */
const getMessage = (queryState, variables, message?: string | ((response, variables) => string)) => {
    return typeof message === 'function'
        ? message(queryState, variables)
        : message
}

//TODO: Define types for data, error, onSettled, pushErrorFunc
const onSettledWrapperFn = (data, error, messageFunc, onSettledFunc, logErrorFunc) => {
    const message = messageFunc()
    if (typeof onSettledFunc === 'function')
        onSettledFunc(data, error)
    if (error)
        logErrorFunc({ error: error, message: message })
}

function parseQueryKitArgs<TOptions extends Record<any, any>>(
    arg1: string | TOptions,
    arg2?: QueryFunction<any, any> | TOptions,
    arg3?: TOptions
): TOptions {
    if (typeof arg1 !== 'string') {
        return arg1 as TOptions
    }

    if (typeof arg2 === 'function') {
        return { ...arg3, primaryKey: arg1, queryFn: arg2 } as unknown as TOptions
    }

    return { ...arg2, primaryKey: arg1 } as unknown as TOptions
}

function parseMutationKitArgs<TOptions extends Record<any, any>>(
    arg1: string | TOptions,
    arg2?: MutationFunction<any, any> | TOptions,
    arg3?: TOptions
): TOptions {
    if (typeof arg1 !== 'string') {
        return arg1 as TOptions
    }

    if (typeof arg2 === 'function') {
        return { ...arg3, mutationKey: arg1, mutationFn: arg2 } as unknown as TOptions
    }

    return { ...arg2, mutationKey: arg1 } as unknown as TOptions
}

export {
    getMessage,
    onSettledWrapperFn,
    parseMutationKitArgs,
    parseQueryKitArgs
}

/* eslint-enable @typescript-eslint/no-explicit-any */